// Action Types
export const SUBMIT_CHAMPION_REQUEST = "SUBMIT_CHAMPION_REQUEST";
export const SUBMIT_CHAMPION_SUCCESS = "SUBMIT_CHAMPION_SUCCESS";
export const SUBMIT_CHAMPION_FAILURE = "SUBMIT_CHAMPION_FAILURE";

// Action Creators
export const submitChampionRequest = (formData) => {
  return (dispatch) => {
    dispatch({
      type: SUBMIT_CHAMPION_REQUEST,
      payload: formData,
    });
  };
};

export const submitChampionSuccess = (message) => ({
  type: SUBMIT_CHAMPION_SUCCESS,
  payload: message,
});

export const submitChampionFailure = (error) => ({
  type: SUBMIT_CHAMPION_FAILURE,
  payload: error,
});